/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/prefer-default-export
import { useReducer } from 'react';
import { toast } from 'react-toastify';
import qs from 'qs';
import axios from 'axios';
import * as keys from '../../services/config/Keys';
import * as types from '../../constants/types/subscribe/SubscribeTypes';
import { SUBSCRIBE_FOR_INTERNET_WITH_SLYDEPAY_URL } from '../../services/api/susbcribe/SubscribeUrl';
import { subscribeReducer } from '../../reducers/subscribe/SubscribeReducer';

// eslint-disable-next-line import/prefer-default-export
export const usePayment = () => {
  const [{ loading }, dispatch] = useReducer(subscribeReducer, {
    loading: false,
  });
  const payForPlanWithFlutterWave = (amount, user) => {
    const { firstName, lastName, phoneNumber, email } = user;
    const x = window.getpaidSetup({
      PBFPubKey: `${keys.FLUTTERWAVE_PUBLIC_KEY}`,
      customer_email: email,
      amount: Number(amount),
      customer_phone: phoneNumber,
      currency: 'GHS',
      country: 'GH',
      payment_options: 'card,account',
      txref: 'rave-tizeti-ghana',
      meta: [
        {
          name: `${firstName} ${lastName}`,
          email,
          phone: phoneNumber,
        },
      ],
      onclose() {},
      callback: (response) => {
        // const txref = response.tx.txRef; // collect txRef returned and pass to a server page to complete status check.
        if (
          response.success === true &&
          response.tx.amount === Number(amount)
        ) {
          toast.success('Transaction successful');
        } else {
          toast.error('Unable to make payment');
        }
        if (
          response.tx.chargeResponseCode === '00' ||
          response.tx.chargeResponseCode === '0'
        ) {
          // redirect to a success page
        } else {
          // redirect to a failure page.
        }
        x.close(); // use this to close the modal immediately after payment.
      },
    });
  };

  const payForRecurringPlanWithFlutterWave = (ravePlanCode, user, amount) => {
    const { email, phoneNumber, firstName, lastName } = user;
    const x = window.getpaidSetup({
      PBFPubKey: `${keys.FLUTTERWAVE_PUBLIC_KEY}`,
      customer_email: email,
      amount,
      customer_phone: phoneNumber,
      currency: 'GHS',
      payment_options: 'card,account',
      txref: `rave-tzt-ghwifi-recurring-${phoneNumber}-${Math.floor(
        Math.random() * 1000000000000000 + 1,
      )}`,
      payment_plan: ravePlanCode,
      meta: [
        {
          name: `${firstName} ${lastName}`,
          email,
          phone: phoneNumber,
        },
      ],
      onclose() {},
      callback(response) {
        const txref = response.data.txRef;
        // collect flwRef returned and pass to a server page to complete status check.
        const { chargeResponseCode } = response.data;
        if (chargeResponseCode == '00' || chargeResponseCode == '0') {
          // if (
          //   response.data.status === 'successful' &&
          //   response.data.amount >= amount &&
          //   response.data.currency == 'GHS'
          // )
          toast.success('Transaction Successful!');
          // redirect to a success page
        } else {
          toast.error('Payment not successful!');
          // redirect to a failure page.
        }
        x.close(); // use this to close the modal immediately after payment.
      },
    });
  };

  const payForPlanWithSlydePay = async (amount, user) => {
    dispatch({
      type: types.START_PAYMENT_WITH_SLYDE,
    });
    const data = qs.stringify({
      action: 'createinvoiceandsend',
      customeremail: user.email,
      description: 'internet installation',
      customername: `${user.firstName} ${user.lastName}`,
      amount: Number(amount),
    });
    try {
      const response = await axios.post(
        `${SUBSCRIBE_FOR_INTERNET_WITH_SLYDEPAY_URL}`,
        data,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );
      if (response.data.status === true) {
        toast.success('Payment initialized');
        dispatch({
          type: types.PAYMENT_WITH_SLYDE_SUCCESS,
        });
        window.open(`${response.data.url}`, '_blank');
      }
    } catch (e) {
      if (e.response) {
        toast.info('Unable to initialize payment');
        dispatch({
          type: types.PAYMENT_WITH_SLYDE_FAILED,
        });
      }
    }
  };

  const payForPlanWithPaystack = (amount, user) => {
    const { firstName, lastName, phoneNumber, email } = user;
    const multipliedAmount = amount * 100;
    const newAmount = 0.02 * multipliedAmount + multipliedAmount;
    const handler = window.PaystackPop.setup({
      key: `${keys.PAYSTACK_PK_GH_LIVE_KEY}`,
      email,
      amount: Math.round(newAmount),
      currency: 'GHS',
      firstname: firstName,
      lastname: lastName,
      ref: `TZT_GHWifi_${phoneNumber}_${Math.floor(
        Math.random() * 1000000000000000 + 1,
      )}`,
      metadata: {
        custom_fields: [
          {
            email,
            amount: newAmount,
            phoneNumber,
          },
        ],
      },
      callback(callbackResponse) {
        if (callbackResponse.status === 'success') {
          const ref = callbackResponse.reference;
          try {
            fetch(
              `https://api.tizeti.com/api/v1/paystack/verify?reference=${ref}&countryCode=gh`,
            ).then(async (response) => {
              const data = await response.json();
              if (
                data.data.status === 'success' &&
                data.data.domain === 'live'
              ) {
                toast.success('Transaction Successful!');
              }
            });
          } catch (e) {
            toast.error('Transaction Failed!');
          }
        } else {
          toast.info('Payment not successful!');
        }
      },
      onClose() {},
    });
    handler.openIframe();
  };

  const payForRecurringPlanWithPaystack = (paystackPlanCode, user) => {
    const { firstName, lastName, phoneNumber, email } = user;
    const handler = window.PaystackPop.setup({
      key: `${keys.PAYSTACK_PK_GH_LIVE_KEY}`,
      email,
      currency: 'GHS',
      plan: paystackPlanCode,
      channels: ['card'],
      firstname: firstName,
      lastname: lastName,
      ref: `TZT_GHWifi_RECUR_${phoneNumber}_${Math.floor(
        Math.random() * 1000000000000000 + 1,
      )}`,
      metadata: {
        custom_fields: [
          {
            email,
            firstname: firstName,
            lastname: lastName,
            phoneNumber,
          },
        ],
      },
      callback(callbackResponse) {
        if (callbackResponse.status === 'success') {
          const ref = callbackResponse.reference;
          try {
            fetch(
              `https://api.tizeti.com/api/v1/paystack/verify?reference=${ref}&countryCode=gh`,
            ).then(async (response) => {
              const data = await response.json();
              if (
                data.data.status === 'success' &&
                data.data.domain === 'live'
              ) {
                toast.success('Transaction Successful!');
              }
            });
          } catch (e) {
            toast.error('Transaction Failed!');
          }
        } else {
          toast.info('Payment not successful!');
        }
      },
      onClose() {},
    });
    handler.openIframe();
  };

  return {
    payForPlanWithFlutterWave,
    payForRecurringPlanWithFlutterWave,
    payForPlanWithSlydePay,
    payForPlanWithPaystack,
    payForRecurringPlanWithPaystack,
    loading,
  };
};
